import React from 'react';

import Icon from '../Icon/Icon';

const SirenBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g strokeWidth='2' fill='none' fillRule='evenodd' strokeLinecap='round'>
                <path
                    d='M24.395 17c5.43-4.148 10.702-4.148 15.814 0'
                    stroke='#00D1D2'
                    className='icon-accent-stroke icon-accent-fill'
                />
                <path
                    d='M7 13.111c5.337 4.148 10.951 4.148 16.843 0 5.891-4.148 11.61-4.148 17.157 0'
                    stroke='#34303D'
                />
                <path
                    d='M8.581 31.778c4.725 4.148 9.018 3.46 14.233-.688'
                    stroke='#00D1D2'
                    className='icon-accent-stroke icon-accent-fill'
                />
                <path
                    d='M7 24c5.337 4.148 10.951 4.148 16.843 0 5.891-4.148 11.61-4.148 17.157 0M7 34.889c5.337 4.148 10.951 4.148 16.843 0 5.891-4.148 11.61-4.148 17.157 0'
                    stroke='#34303D'
                />
            </g>
        </Icon>
    );
};

export default SirenBlueIcon;
